import { Navigate } from "react-router";
import { useFeatureAccess } from "../../util/useFeatureAccess";

type Props = {
    feature: string;
    children: React.ReactNode;
};

export default function FeatureGate({ feature, children }: Props) {
    const { isFeatureEnabled } = useFeatureAccess();

    if (!isFeatureEnabled(feature)) {
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
}
